<template>
  <div class="home">
    <!-- 三维画布 -->
    <div id="watermark"></div>
    <div id="BottomInfo"><span class="shine">Designed By Sumhoo Technology</span></div>  
    <div id="canvas"></div>
    <tophead-Bar></tophead-Bar>
    <homecontainer-Bar @transfer="transfer" @modelButton = "modelButton"></homecontainer-Bar>
  </div>
</template>

<script>
import ThreeDimensional from "../assets/threejs/ThreeDimensional.js"
import topheadBar from "@/components/top-head.vue"
import homecontainerBar from "@/components/home-container.vue" 
let ThreeDimen 
export default {
  name: 'HomeView',
  components: {
    topheadBar,
    homecontainerBar,
  },
  data(){
    return{
      checkedNav:""
    }
  },
  mounted(){
    this.$nextTick(()=>{
      ThreeDimen = new ThreeDimensional("canvas");
      this.addWaterMarker();
    })
  },
  methods:{
    transfer(value){
     this.checkedNav = value;
     ThreeDimen.SetcMType_out(this.checkedNav);
    },
    modelButton(value){
      ThreeDimen.EventClick(value);
    },
    addWaterMarker() {
      let img = new Image();
      img.setAttribute("crossOrigin", 'Anonymous');
      img.src = "https://sumhoo.oss-cn-shenzhen.aliyuncs.com/images/waterMark.png";
      var can = document.createElement('canvas');
      var watermark = document.getElementById('watermark');
      watermark.appendChild(can);
      can.width = 376; //画布的宽
      can.height = 282;//画布的高度
      can.style.display = 'none';
      var cans = can.getContext('2d');
      img.onload = () => {
        cans.drawImage(img, 50, 0, 180, 140);
        watermark.style.backgroundImage = "url(" + can.toDataURL("image/png") + ")"; //把画布插入到body中
        watermark.style.opacity = 0.3;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .home{
    width: 100vw;
    height: 100vh;
  }
  #canvas{
    width: 100%;
    height: 100%;
  }
  .homde_head {
    width: calc(100% - 0px);
    height: 70px;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
  }
   #watermark {
    position: absolute;
    width: 100%;
    height: 100%;
    pointer-events: none;
    /* 上层加上这句样式可以实现点击穿透 */
    float: left;
  }
   .shine {
    width: calc(100% - 300px);
    height: 60px;
    margin-left: -200px;
    font-weight: 200;
    font-family: Arboria;
    font-size: 1vw;
    text-align: center;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-color: #19385c;
    // background-image: -webkit-linear-gradient(-45deg, #0fffff 30%, #aff0ff 50%, #aff0ff 70%);
    background-image: -webkit-linear-gradient(-45deg, rgba(0, 0, 0, 0.6) 30%, #aff0ff 50%, rgba(0, 0, 0, 0.6) 70%);
    background-blend-mode: hard-light;
    background-size: 200%;
    -webkit-animation: shine 2s infinite
  }

  #BottomInfo {
    position: absolute;
    left: 118px;
    bottom: 8%;
    width: 100%;
    height: 3.5%;
    text-align: center;
    background-size: 100% 100%;
    pointer-events: none
  }
</style>
